export interface ImmigrationDetailsState {
    immigrationDetails: any | null;
  }
  export const initialImmigrationDetailsState: ImmigrationDetailsState = {
    immigrationDetails: null
  };